import { Injectable } from '@angular/core';

export enum indexersType {
    PREFIXADO = "PRE"
}

@Injectable({ providedIn: 'root' })
export class FinanceService {

    private indexes: any = null;
    private indexesAgregate: any = null;
    private indexQuote: any = null;
    private taxTable: any = null;

    constructor() { }

    /**
     * FAZ CALCULO DA PORCENTAGEM DE RENTABILIDADE TOTAL
     * 
     * @param interestRate taxa mensal de rentabilidade
     * @param timeEstimate tempo estimado para projeção em meses
    */
    calculateTotalProfitability(interestRate: number | string, timeEstimate: number | string) {
        return ((1 + +interestRate) ** +timeEstimate) -1;
    }

    /**
     * FAZ O CÁLCULO DA PORCENTAGEM DE RENTABILIDADE TOTAL
     * CONSIDERANDO O INDEXADOR E A TAXA DE VARIAÇÃO
     * 
     * @param indexer indexador para fazer o calculo da rentabilidade caso não seja PRÉ-FIXADO (PRÉ-FIXADO, CDI, IPCA, etc)
     * @param indexerID ID indexador para fazer o calculo da rentabilidade
     * @param timeEstimate tempo estimado para projeção em meses
     * @param interestRate taxa mensal de rentabilidade
     */
    calculateProfitabilityInEstimatedTIme(indexer: string = null, indexerID: number | string = null, timeEstimate: number | string, interestRate: number) {
        interestRate = this.calculateInterestRate(indexer, indexerID, timeEstimate, interestRate);
        return this.calculateTotalProfitability(interestRate/100, timeEstimate);
    }

    /**
     * FAZ O CALCULO SIMPLES DA PROJEÇÃO CONFORME CALCULO:
     * valor inicial * ((1 + taxa mensal) elevado ao tempo estimado)
     * 
     * @param initialValue valor inicial do investimento para simulação
     * @param interestRate taxa mensal de rentabilidade
     * @param timeEstimate tempo estimado para projeção em meses
     * @param valueTax taxa de imposto de renda aplicada no cálculo, por padrão será zero
     */
    calculateProjection(initialValue: number | string, interestRate: number | string, timeEstimate: number | string, valueTax: number = 0) {
        let valueProjection = ((1 + +interestRate/ 100) ** +timeEstimate) - 1;
        if (valueTax) valueProjection = +valueProjection / (1 - (valueTax/100));
        return +initialValue + (+initialValue * valueProjection);
    }

    /**
     * FAZ CONVERSÃO DE TAXA ANUAL PARA MENSAL
     * 
     * @param interestRate taxa anual de rentabilidade
     */
    convertAnualRate(interestRate: number | string) {
        return ((1 + (+interestRate / 100)) ** (1 / 12)) - 1;
    }

    /**
     * FAZ CALCULO DE PROJEÇÃO PARA VENDA GUIADA CONSIDERANDO DEPOSITO DE VALORES MENSAIS
     * 
     * @param initialValue valor inicial do investimento para simulação
     * @param interestRate taxa mensal de rentabilidade
     * @param timeEstimate tempo estimado para projeção em meses
     * @param monthlyApplication valor de aplicação mensal
     */
    calculateProjectionGuidedSale(initialValue: number | string, interestRate: number | string, timeEstimate: number | string, monthlyApplication: any) {
        return (+initialValue * ((1 + +interestRate/ 100) ** +timeEstimate)) +  ( +monthlyApplication * ( ( ( ( 1 + +interestRate/100 ) ** +timeEstimate ) - 1 ) / (+interestRate/100) ) );
    }

    /**
     * PEGA OS DADOS INFORMADOS DO USUARIO, CONFERE O INDEXADOR E PEGA O VALOR DA TAXA MENSAL
     * E DECIDE SE FAZ O CALCULO DE VENDA GUIADA OU PROJEÇÃO NORMAL
     * 
     * @param initialValue valor inicial do investimento para simulação
     * @param interestRate taxa mensal de rentabilidade ou anual em caso de PRÉ-FIXADO
     * @param timeEstimate tempo estimado para projeção em meses
     * @param indexer indexador para fazer o calculo da rentabilidade caso não seja PRÉ-FIXADO (PRÉ-FIXADO, CDI, IPCA, etc)
     * @param indexerID ID indexador para fazer o calculo da rentabilidade
     * @param monthlyApplication valor de aplicação mensal para casos de venda guiada
     * @param isentIR passa se o produto é isento de imposto de renda, por padrão é falso
     */
    calculateTax(initialValue: number | string = null, interestRate: number | string = null, timeEstimate: number | string = null, indexer: string = null, indexerID: number | string = null, monthlyApplication: number | string = null, isentIR: boolean = false) {
        interestRate = this.calculateInterestRate(indexer, indexerID, timeEstimate, interestRate);

        let valueTax = 0;
        if (isentIR && this.taxTable) {
            const value = this.taxTable.find((a)=> a.numberDays == 0)
            valueTax = value.taxValue;
            this.taxTable.forEach(tax => {
                if (+tax.numberDays != 0) {
                    if (((+timeEstimate*30) <= +tax.numberDays) && (valueTax == value.taxValue)) valueTax = tax.taxValue;
                }
            });
        }

        if (monthlyApplication) {
            return this.calculateProjectionGuidedSale(initialValue, interestRate, timeEstimate, monthlyApplication);
        }

        return this.calculateProjection(initialValue, interestRate, timeEstimate, valueTax);
    }

    /**
     * CALCULA A TAXA DE RENTABILIDADEF
     * 
     * @param indexer indexador para fazer o calculo da rentabilidade caso não seja PRÉ-FIXADO (PRÉ-FIXADO, CDI, IPCA, etc)
     * @param indexerID ID indexador para fazer o calculo da rentabilidade
     * @param timeEstimate tempo estimado para projeção em meses
     * @param interestRate taxa mensal de rentabilidade ou anual em caso de PRÉ-FIXADO
     */
    calculateInterestRate(indexer: string = null, indexerID: number | string = null, timeEstimate: number | string = null, interestRate: number | string = null) {
        interestRate = +interestRate;

        if (indexer == indexersType.PREFIXADO) interestRate = this.convertAnualRate(interestRate) * 100;
        
        let indexerRate = null,
            actualIndex = null,
            actualIndexAgregated = null,
            defaultValue = 0;

        if (indexer && indexer !== indexersType.PREFIXADO) {
            if (!this.indexes || !this.indexesAgregate) return;
            actualIndex = this.indexes.find(x => (x.indexName === indexer) ) || this.indexes.find(x => (x.indexID === indexerID) );
            actualIndexAgregated = this.indexesAgregate.find(x => (x.name === indexer) ) || this.indexesAgregate.find(x => (x.id === indexerID) );

            defaultValue = actualIndex.defaultValue;
            if (this.indexQuote) {
                let date = new Date();
                date = new Date(date.setDate(date.getDate() + (+timeEstimate*30) ));
                let valueYear = this.indexQuote.value.filter((data) => ((data.indexID === actualIndex.indexID) && (new Date(data.quoteDate).getMonth() == date.getMonth() && new Date(data.quoteDate).getFullYear() == date.getFullYear())))
                if (valueYear.length) defaultValue = valueYear[0].quoteValue;
            }

            if ((actualIndex && actualIndexAgregated && actualIndexAgregated.aggregate) || indexer == 'Poupança') interestRate = (interestRate * defaultValue);
            else if (actualIndex && actualIndexAgregated && !actualIndexAgregated.aggregate) interestRate = ((( ((1 + (+interestRate / 100)) ** (1 / 12)) * (1 + defaultValue)) - 1)*100);
            else interestRate = 0;
        }

        return interestRate;
    }

    /**
     *  RETORNA O VALOR DE ANOS ESTIMADOS PARA PREENCHER O GRAFICO
     * 
     * @param initialValue valor inicial do investimento
     * @param interestRate taxa mensal de rentabilidade ou anual em caso de PRÉ-FIXADO
     * @param indexer indexador para fazer o calculo da rentabilidade caso não seja PRÉ-FIXADO (PRÉ-FIXADO, CDI, IPCA, etc)
     * @param indexerID ID indexador para fazer o calculo da rentabilidade
     * @param monthlyApplication valor de aplicação mensal para casos de venda guiada
     * @param years tempo em anos para a geração de array deste tamanho
     * @param isentIR passa se o produto é isento de imposto de renda, por padrão é falso
     */
    calculateGraphic(initialValue: number | string = null, interestRate: number | string = null, indexer: string = null, indexerID: number | string = null, monthlyApplication: number | string = null, years: number, isentIR: boolean = false) {
        let arrResult: number[] = [],
            value = initialValue;

        arrResult.push(+value);

        for (var i = 1; i <= years; i++) {
            value = +this.calculateTax(initialValue, interestRate, (i*12), indexer, indexerID, monthlyApplication, isentIR);
            arrResult.push(value);
        }

        return arrResult;
    }

    /**
     * ATUALIZA LISTA DE INDEXES
     * 
     * @param indexes table de índices (research/indexer) obtiva na rota de indexer em research
     */
    updateIndexes(indexes: any) {
        this.indexes = indexes;
    }

    /**
     * ATUALIZA LISTA DE INDEXES AGREGADOS
     * 
     * @param indexes table de índices agregados (fixedincome/indexer) obtiva na rota de indexer em fixedincome
     */
    updateIndexesAgregate(indexes: any) {
        this.indexesAgregate = indexes;
    }

    /**
     * ATUALIZA LISTA DE INDEXES QUOTE
     * 
     * @param indexes table de índices quote (research/indexquote) obtiva na rota de indexer em research
     */
    updateIndexQuote(indexes: any) {
        this.indexQuote = indexes;
    }

    /**
     * ATUALIZA TABELA DE IMPOSTO DE RENDA
     * 
     * @param table table de taxas de imposto de renda (research/tax) obtiva na rota de indexer em research
     */
    updateTaxTable(table: any) {
        this.taxTable = table;
    }

    /**
     * RETORNA SE JÁ EXISTEM TODAS AS TABELAS NECESSÁRIAS PARA O CÁLCULO
     */
    hasAllTables() {
        if (this.indexes && this.indexesAgregate && this.indexQuote && this.taxTable)
            return true
        else 
            return false;
    }

    /**
     * RESGATE
     * RETORNA O VALOR CALCULADO DO RESGATE (não antecipado)
     * 
     * @param currentValue valor atual
     * @param pendingRedeemValue valor de resgate pendente
     * @param scheduleRedeemValue valor de resgate agendado
     * @param blockedValue valor bloqueado
     */
    calculateRedeemValue(currentValue: any, pendingRedeemValue: any, scheduleRedeemValue: any) {
        return currentValue - Math.abs(pendingRedeemValue - scheduleRedeemValue);
    }

    /**
     * RESGATE ANTECIPADO
     * RETORNA O VALOR CALCULADO DO RESGATE ANTECIPADO
     * 
     * @param anticipateUnitPrice preço unitário do resgate antecipado
     * @param currentQuantity quantidade atual
     * @param pendingRedeemQuantity quantidade de resgate pendente
     * @param scheduleRedeemQuantity quantidade de resgate agendado
     */
    calculateAnticipateRedeemValue(anticipateUnitPrice: any, currentQuantity: any, pendingRedeemQuantity: any, scheduleRedeemQuantity: any) {
        return anticipateUnitPrice * (currentQuantity - pendingRedeemQuantity - scheduleRedeemQuantity);
    }

}